import { Field } from 'redux-form'

import WrappedRadio from 'components/Shared/Forms/WrappedRadio'
import { useEffect, useState } from 'react'
import { shuffleArray } from 'utils/arrays'

const personaOptionsData = [
  {
    radioValue: 'Intentional',
    label:
      'I already have branding, logos, and data for my app that I want to import to Adalo',
  },
  {
    radioValue: 'Browsing',
    label: "I have an idea and I'm browsing different tools",
  },
  {
    radioValue: 'DIY',
    label: "I'll explore on my own!",
  },
]
const PersonaOptions = (): JSX.Element => {
  const [randomizedOptions, setRandomizedOptions] = useState<
    typeof personaOptionsData
  >([])
  useEffect(() => {
    setRandomizedOptions(
      shuffleArray([...personaOptionsData]) as typeof personaOptionsData
    )
  }, [])

  return (
    <>
      {randomizedOptions.map(option => (
        <Field
          key={option.radioValue}
          className="new-app-hiring-option"
          component={WrappedRadio}
          styled
          name="persona"
          radioValue={option.radioValue}
          label={option.label}
        />
      ))}
    </>
  )
}

export default PersonaOptions
